<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("note_module_settings") }}
      </h1>
    </div>

    <!-- Configuraciones específicas del módulo -->
    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("general_settings") }}</h1>

        <!-- Checkbox para auto-guardado -->
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_auto_save"
            v-model="meta.auto_save"
          />
          <label for="chk_auto_save">{{ $t("auto_save") }}</label>
        </div>

        <!-- Checkbox para habilitar compartir -->
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_enable_sharing"
            v-model="meta.enable_sharing"
          />
          <label for="chk_enable_sharing">{{ $t("enable_sharing") }}</label>
        </div>

        <!-- Checkbox para habilitar archivado -->
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_enable_archiving"
            v-model="meta.enable_archiving"
          />
          <label for="chk_enable_archiving">{{ $t("enable_archiving") }}</label>
        </div>

        <!-- Dropdown para categoría por defecto -->
        <div class="field">
          <generic-dropdown
            :title="$t('default_category')"
            :placeholder="$t('select_category')"
            :is_multiple="false"
            url="/note/category/catalog"
            name_field="name"
            value_field="category_id"
            @selected="default_category_selected"
            ref="default_category_dropdown"
          />
        </div>

        <!-- Número máximo de notas recientes -->
        <div class="field">
          <label class="label">{{ $t("max_recent_notes") }}</label>
          <input
            type="number"
            class="input"
            v-model="meta.max_recent_notes"
            min="5"
            max="50"
          />
        </div>
      </div>
    </div>

    <!-- Botón de guardar -->
    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "NoteSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {
        auto_save: true,
        enable_sharing: true,
        enable_archiving: true,
        default_category_id: null,
        max_recent_notes: 10,
      },
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("configuration_saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    default_category_selected(value) {
      this.meta.default_category_id = value.category_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = { ...v.meta, ...conf };
          // Establecer valores en dropdowns después de cargar
          if (conf.default_category_id) {
            v.$refs.default_category_dropdown.set_value(
              conf.default_category_id
            );
          }
        }
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>
